module.exports = __webpack_public_path__ + "img/naver.0f5ff292.png";